// extracted by mini-css-extract-plugin
export default {"button":"profile-edit_button__M6VAm"};